// extracted by mini-css-extract-plugin
export default {"box":"SecondBox_box__1bcKm","title":"SecondBox_title__IdCnI"};